import Base from "./_BaseComponent";
import $ from "jquery";
import "@fancyapps/fancybox";

class Gallery extends Base.Component {

	public onMount(): void {
		const loaded = true;
	}

}

export default Base.Init("[data-component-gallery]", Gallery);
